import React from 'react';
import { MuiPickersUtilsProvider, DatePicker } from 'material-ui-pickers';
import DateFnsUtils from '@date-io/date-fns';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';

const materialTheme = createMuiTheme({
  typography: {
    fontFamily: ['Kanit', 'sans-serif'].join(','),
    useNextVariants: true,
  },
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: '#009D9A',
      },
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        backgroundColor: 'white',
        color: '#009D9A',
      },
    },
    MuiOutlinedInput: {
      input: {
        padding: 7,
        height: '24px',
      },
      notchedOutline: {
        border: '1px solid #B8CFC3 !important',
        borderRadius: '2px',
      },
    },
    MuiPickersCalendar: {
      transitionContainer: {
        minHeight: '265px',
      },
    },
    MuiPickersDay: {
      isSelected: {
        backgroundColor: '#009D9A',
        opacity: '70%',
      },
      day: {
        fontSize: '0.85rem',
      },
    },
    MuiButton: {
      root: {
        color: '#009D9A !important',
      },
    },
    MuiTypography: {
      caption: {
        fontSize: '0.85rem',
      },
    },
  },
});

const CalendarDateRange = (props) => {
  const onStartDateChange = props.onStartDateChange ? props.onStartDateChange : (_) => {};
  const onEndDateChange = props.onEndDateChange ? props.onEndDateChange : (_) => {};
  const startDate = props.startDate ? props.startDate : new Date();
  const endDate = props.endDate ? props.endDate : new Date();

  const customStyle = {
    width: 110,
    marginTop: 4,
  };
  return (
    <MuiThemeProvider theme={materialTheme}>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <div className='flex'>
          <div className='mx-4 my-0 mt-3 font-medium text-summary-header'>{props.startDateLable}</div>
          <DatePicker
            maxDate={new Date()}
            views={['year', 'month', 'day']}
            variant='outlined'
            style={customStyle}
            format='dd/MM/yyyy'
            value={startDate}
            onChange={(e) => onStartDateChange(e)}
          />
          <div className='mx-4 my-0 mt-3 font-medium text-summary-header'>{props.endDateLable}</div>
          <DatePicker
            minDate={new Date(startDate)}
            maxDate={new Date()}
            views={['year', 'month', 'day']}
            variant='outlined'
            style={customStyle}
            format='dd/MM/yyyy'
            value={endDate}
            onChange={(e) => onEndDateChange(e)}
          />
        </div>
      </MuiPickersUtilsProvider>
    </MuiThemeProvider>
  );
};

export default CalendarDateRange;
